import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import { PageHead, Card, Pill, Loading, Err, tableStyles, EmptyState } from "./_shared";
import { Webhook as WebhookIcon, ShieldCheck, KeyRound, Activity } from "lucide-react";

export default function Webhooks() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/api/admin/webhooks").then((d) => setItems(d.items || [])).catch((e) => setErr(e.message));
  }, []);
  if (err) return <Err msg={err} />;

  return (
    <div data-testid="admin-webhooks">
      <PageHead title="Webhooks" sub="Outbound event delivery" right={<Pill tone="warn">Read-only · Turn D</Pill>} />

      <div style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr", gap: 16 }}>
        <Card title={`Recent webhook events · ${items?.length ?? 0}`}>
          {!items ? <Loading /> : items.length === 0 ? (
            <EmptyState
              title="No webhook events yet"
              description="When workspaces fire jobs, complete billing transactions, or trigger automations, the events that would be delivered to subscribers will appear here. Webhook subscription management ships in Turn D."
            />
          ) : (
            <table style={tableStyles.table}>
              <thead><tr>
                <th style={tableStyles.th}>When</th>
                <th style={tableStyles.th}>Event</th>
                <th style={tableStyles.th}>Endpoint</th>
                <th style={tableStyles.th}>Status</th>
              </tr></thead>
              <tbody>
                {items.map((e) => (
                  <tr key={e.id} style={{ borderTop: "1px solid var(--pl-border)" }}>
                    <td style={{ ...tableStyles.td, fontSize: 11 }}>{(e.created_at || "").slice(0, 19)}</td>
                    <td style={{ ...tableStyles.td, fontWeight: 700 }}>{e.event_type || "—"}</td>
                    <td style={{ ...tableStyles.td, fontFamily: "JetBrains Mono, monospace", fontSize: 11 }}>{e.endpoint_url || "—"}</td>
                    <td style={tableStyles.td}><Pill tone={e.status === "delivered" ? "success" : "warn"}>{e.status || "pending"}</Pill></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card>

        <Card title="What ships in Turn D">
          <FeatureRow icon={<WebhookIcon size={14} />} label="Endpoint CRUD" sub="Create, rotate, disable workspace endpoints" />
          <FeatureRow icon={<KeyRound size={14} />} label="HMAC signing" sub="Auto-rotated per-endpoint signing secrets" />
          <FeatureRow icon={<Activity size={14} />} label="Delivery retries" sub="Exponential backoff with delivery log" />
          <FeatureRow icon={<ShieldCheck size={14} />} label="Allow-listed events" sub="Per-endpoint event-type subscription filters" />
        </Card>
      </div>
    </div>
  );
}

function FeatureRow({ icon, label, sub }) {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "8px 0", borderBottom: "1px dashed var(--pl-border)" }}>
      <span style={{ color: "var(--pl-aqua)", marginTop: 2 }}>{icon}</span>
      <div>
        <div style={{ fontSize: 12.5, fontWeight: 800 }}>{label}</div>
        <div style={{ fontSize: 11, color: "var(--pl-text-muted)", marginTop: 2 }}>{sub}</div>
      </div>
    </div>
  );
}
